import { Link } from '@inertiajs/react';
export default function ExploreBrandCard({ brand }) {
    // Only published brands reach this card (BrandController::exploreBrands),
    // so /{slug} always resolves to a real hub page rather than a 302.
    return (<Link href={`/${brand.slug}`} className="mx-2 flex h-[60px] items-center justify-center rounded-md border border-gray-200 bg-white px-4 text-sm text-gray-900 transition hover:border-gray-400 hover:shadow-sm">
            {brand.name}
        </Link>);
}
